import { FieldArray } from 'react-final-form-arrays';
import { v4 as uuidv4 } from 'uuid';

import {
  IKnmErknmFormViolation,
  IKnmErknmFormViolationEvent,
} from 'KnmErknmPackage/ErknmViolationsModule/interfaces/IKnmErknmFormViolation';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { ErknmActViolationEventItem } from 'KnmErknmPackage/ErknmViolationsModule/components/ErknmActViolationEventItem';
import {
  createPassportEventSelectOptions,
  IViolationEventSelectOption,
} from 'KnmErknmPackage/ErknmViolationsModule/common/createPassportEventSelectOptions';
import { IKnmErknmFormEvent } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormEvent';

interface IErknmActViolationEventItemsProps {
  name: string;
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
  passportEvents: IKnmErknmFormEvent[] | undefined;
  watchOnly: boolean;
  hasUnsignedAct?: boolean;
  isKnm?: boolean;
  isPm?: boolean;
  isDecision?: boolean;
  id: string;
}

export const createEmptyViolationEvent = (
  eventOption: IViolationEventSelectOption | null,
): Partial<IKnmErknmFormViolationEvent> => ({
  guid: uuidv4(),
  eventOption,
  isNew: true,
  materials: [
    {
      guid: uuidv4(),
      isNew: true,
      videoFixations: [
        {
          guid: uuidv4(),
          videoFixationOption: null,
        },
      ],
      typeDocConfirmationViolation: null,
      attachments: null,
      links: null,
    },
  ],
});

export const getAvailablePassportEventOptions = (
  violation: IKnmErknmFormViolation,
  passportEvents: IKnmErknmFormEvent[] | undefined,
): IViolationEventSelectOption[] => {
  const allEventOptions = createPassportEventSelectOptions(passportEvents);
  const usedEventGuids = new Set((violation.events || []).map(item => item.eventOption?.value).filter(Boolean));

  return allEventOptions.filter(option => !usedEventGuids.has(option.value));
};

export const ErknmActViolationEventItems = ({
  name,
  formRef,
  passportEvents,
  watchOnly,
  hasUnsignedAct = false,
  isKnm,
  isPm,
  isDecision,
  id,
}: IErknmActViolationEventItemsProps) => {
  const eventsFieldName = `${name}.events`;

  return (
    <FieldArray name={eventsFieldName}>
      {({ fields }) =>
        fields.map((eventFieldName, index) => {
          const eventValue: IKnmErknmFormViolationEvent = fields.value[index];
          const canEdit = !!(eventValue.isNew || hasUnsignedAct) && !watchOnly;

          return (
            <ErknmActViolationEventItem
              key={eventValue.guid}
              event={eventValue}
              eventIdx={index}
              fieldName={eventFieldName}
              name={name}
              events={fields.value}
              passportEvents={passportEvents}
              formRef={formRef}
              canEdit={canEdit}
              isKnm={isKnm}
              isPm={isPm}
              isDecision={isDecision}
              id={`${id}.events[${index}]`}
            />
          );
        })
      }
    </FieldArray>
  );
};
